var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showOr)?_c('div',{staticClass:"mat-header"},[_c('h2',[_vm._v("特许全球金融科技师(CGFT)考试报名系统")]),_vm._v(" "),_c('div',[_vm._v("\n    您好， "+_vm._s(_vm.$store.state.UserInfo.userName || _vm.userInfo.userName)+"！"),_c('span',{staticClass:"logout",on:{"click":_vm.logout}},[_vm._v("\n      退出\n    ")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15e1e23e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MatHeader.vue
// module id = null
// module chunks = 